import * as i0 from '@angular/core';
import { Directive, Inject, NgModule } from '@angular/core';
import { TuiResizeService, TuiDestroyService } from '@taiga-ui/cdk/services';
import * as i1 from 'rxjs';

class TuiResizeDirective {
    constructor(tuiResize) {
        this.tuiResize = tuiResize;
    }
}
TuiResizeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiResizeDirective, deps: [{ token: TuiResizeService }], target: i0.ɵɵFactoryTarget.Directive });
TuiResizeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: TuiResizeDirective, selector: "[tuiResize]", outputs: { tuiResize: "tuiResize" }, providers: [TuiDestroyService, TuiResizeService], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiResizeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[tuiResize]',
                    outputs: ['tuiResize'],
                    providers: [TuiDestroyService, TuiResizeService],
                }]
        }], ctorParameters: function () { return [{ type: i1.Observable, decorators: [{
                    type: Inject,
                    args: [TuiResizeService]
                }] }]; } });

/**
 * @experimental
 */
class TuiResizeModule {
}
TuiResizeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiResizeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiResizeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiResizeModule, declarations: [TuiResizeDirective], exports: [TuiResizeDirective] });
TuiResizeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiResizeModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiResizeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiResizeDirective],
                    exports: [TuiResizeDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiResizeDirective, TuiResizeModule };
